import { toast } from 'sonner';

const toastStyle = {
    default: {
        padding: '1rem',
    }
};

export const toastUtils = {
  success: (message: string) => toast.success(message, {style: {...toastStyle.default}}),
  error: (message: string) => toast.error(message, {style: {...toastStyle.default}}),
  info: (message: string) => toast.info(message, {style: {...toastStyle.default}}),
  warning: (message: string) => toast.warning(message, {style: {...toastStyle.default}}),
  loading: (message: string) => toast.loading(message, {style: {...toastStyle.default}}),
  dismiss: (id: string | number) => toast.dismiss(id),

};
